// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","card__img":"Card_card__img__gl4P4"};